import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { Logo } from "./Logo";
import { useAuth } from "../../context/AuthContext";

const COLS = [
  { title: "Store", links: [["/products", "Digital Products"], ["/how-it-works", "How It Works"], ["/register", "Create Account"], ["/login", "Log In"]] },
  { title: "Company", links: [["/about", "About Raphanex"], ["/contact", "Contact"], ["/faq", "FAQ"]] },
  { title: "Legal", links: [["/terms", "Terms of Service"], ["/privacy", "Privacy Policy"], ["/refund-policy", "Refund Policy"], ["/payment-policy", "Payment Policy"]] },
];

export const Footer = () => {
  const { site } = useAuth();
  const store = site?.store || {};
  return (
    <footer className="border-t border-white/[0.06] bg-[#080b12]" data-testid="site-footer">
      <div className="mx-auto grid max-w-7xl gap-12 px-5 py-16 lg:grid-cols-5 lg:px-8">
        <div className="lg:col-span-2">
          <Logo />
          <p className="mt-5 max-w-sm text-sm leading-relaxed text-slate-400">
            {store.tagline || "Premium digital products, delivered instantly."} Prices in Ghana Cedis (GH₵).
          </p>
          <div className="mt-6 inline-flex items-center gap-2 rounded-full border border-emerald-500/20 bg-emerald-500/5 px-3 py-1.5 text-xs text-emerald-300">
            <ShieldCheck size={14} /> Payments secured by theteller
          </div>
        </div>
        {COLS.map((c) => (
          <div key={c.title}>
            <h4 className="text-sm font-semibold text-white">{c.title}</h4>
            <ul className="mt-4 space-y-3">
              {c.links.map(([to, label]) => (
                <li key={to}>
                  <Link to={to} className="text-sm text-slate-400 transition-colors hover:text-emerald-300">{label}</Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="border-t border-white/[0.05]">
        <div className="mx-auto flex max-w-7xl flex-col gap-2 px-5 py-6 text-xs text-slate-500 sm:flex-row sm:justify-between lg:px-8">
          <span>© {new Date().getFullYear()} {store.store_name || "Raphanex Store"}. All rights reserved.</span>
          <span>{store.address || "Accra, Ghana"} · {store.support_email}</span>
        </div>
      </div>
    </footer>
  );
};
